import { ReactNode } from "react";

type Props = {
  title: string;
  logoUrl: string;
  description: ReactNode | string;
  installLink?: string;
  helpCenterLink?: string;
};

const IntegrationCard = (props: Props) => {
  return (
    <div className="flex flex-col justify-between bg-white p-6">
      <div>
        <div className="mb-2 flex gap-4">
          {props.logoUrl && (
            <img
              src={props.logoUrl}
              alt={`${props.title} logo`}
              className="h-6"
            />
          )}
          <h5 className="font-serif text-lg font-medium leading-6">
            {props.title}
          </h5>
        </div>
        <span className="font-serif leading-[26px] text-dm-gray-500">
          {props.description}
        </span>
      </div>
      {props.installLink && (
        <a href={props.installLink} className="mt-8 text-blue-500">
          Learn How to Install <i className="far fa-solid fa-arrow-right"></i>
        </a>
      )}
      {props.helpCenterLink && (
        <a href={props.helpCenterLink} className="mt-8 text-blue-500">
          Help Center <i className="far fa-solid fa-external-link-alt ml-1"></i>
        </a>
      )}
    </div>
  );
};

export default IntegrationCard;
